import { toUnicode } from 'punycode';
import { SiteUrlButtonProps } from '../types';
import { ClickOutButton } from './ClickoutButton';
import { ShareButton } from './ShareButton/ShareButton';

export const SiteUrlButton = ({
    business,
    onClickOutClick,
    onShare,
    isBlogger,
    ...other
}: SiteUrlButtonProps) => {
    const siteText =
        business.links?.shortSite || business.links?.siteDisplay || business.links?.site;
    const decodedSiteText = siteText && toUnicode(siteText);

    if (decodedSiteText && business.links?.site && !isBlogger) {
        return (
            <ClickOutButton
                text={decodedSiteText}
                url={business.links?.site}
                onClick={onClickOutClick}
                {...other}
            />
        );
    }

    return <ShareButton {...other} onShare={onShare} />;
};
